import PcComponentPage from "./pc-component.page";

export default PcComponentPage;
